import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
// import classNames from 'classnames'
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
// import Link from 'next/link'
// import {connect} from 'react-redux'
// import AppBar from '../Tools/AppBar'
// import List from '@mui/material/List'
// import { Divider } from '@mui/material'
// import Switch from '@mui/material/Switch'
// import dhl from 'public/image/couriers/dhl.svg'
// import ReplyIcon from '@mui/icons-material/Reply'
// import ListItem from '@mui/material/ListItem'
import { withStyles } from "@mui/styles";
import React from "react";
// import ListItemIcon from '@mui/material/ListItemIcon'
// import ListItemText from '@mui/material/ListItemText'
// import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
// import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded'
// import Tooltip from '@mui/material/Tooltip'
// import IconButton from '@mui/material/IconButton'
// import Table from '@mui/material/Table'
// import TableBody from '@mui/material/TableBody'
// import TableCell from '@mui/material/TableCell'
// import TableHead from '@mui/material/TableHead'
// import TableRow from '@mui/material/TableRow'
import TemplateSetRate from "./templateSetRate";

const styles = (theme) => ({
  wrap: {
    marginTop: 16,
    "&:first-of-type": {
      marginTop: 0,
    },
  },
  rateBody: {
    padding: "16px 16px 0",
  },
  category: {
    display: "flex",
    background: "#f8f8f8",
    display: "flex",
    alignItems: "center",
    padding: "0 16px 0 8px",
    "&:hover": {
      background: "#e9e9e9",
    },
  },
  categoryImage: {
    // display: 'flex',
    "&>img": {
      height: 70,
      width: 70,
    },
  },
  categoryTitle: {
    flex: 1,
  },
  categoryIconInactive: {
    transform: "rotate(90deg)",
  },
  categoryIconActive: {
    transform: "rotate(270deg)",
  },
  templateSetList: {
    transform: "height 1s",
    overflow: "hidden",
    // padding: 8
  },
  show: {
    height: "auto",
  },
  hidden: {
    height: 0,
  },
});

class TemplateSetList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shippingProfile: {},
      categories: [],
    };
  }

  appBarProps = {
    showBreadcrumbs: true,
    breadcrumbs: [
      {
        name: "Dashboard",
        link: "/dashboard/home",
      },
      {
        name: "Shipping",
        link: "/dashboard/shipping",
      },
      {
        name: this.props.id || "Profile",
        // link: ''
      },
    ],
  };

  componentDidMount() {
    const { rates, onRef } = this.props;
    this.sortCategory(rates);
    if (onRef) {
      onRef(this);
    }
    // this.setState({
    //   shippingProfile: dashboard.shippingProfile.shipping_profile
    // })
  }

  sortCategory(rates) {
    let categories = [];
    rates.forEach((item) => {
      let index = this.findCategory(item, categories);

      if (index === -1) {
        index = categories.length;
        categories.push({
          open: false,
          name: item.category ? item.category.name : "",
          src: item.category ? item.category.image : "",
          key: item.category ? item.category.key : "",
          sortIndex: item.category ? item.category.sortIndex : "",
          rates: [],
        });

        categories.sort(function (a, b) {
          return a.sortIndex - b.sortIndex;
        });
      }

      categories[index].rates.push(item);
    });

    this.setState({
      categories: categories,
    });
  }

  findCategory(rate, categories) {
    for (let i = 0; i < categories.length; i++) {
      let category = categories[i];
      if (rate.category && rate.category.key === category.key) {
        return i;
      }
    }
    return -1;
  }

  clickCategory(index) {
    let { categories } = this.state;
    categories[index].open = !categories[index].open;

    this.setState({
      categories: categories,
    });
  }

  render() {
    const { classes } = this.props,
      { categories } = this.state;

    return (
      <div className={classes.rateBody}>
        {categories.map((category, index1) => {
          return (
            <div key={index1} className={classes.wrap}>
              <div
                className={classes.category}
                onClick={() => this.clickCategory(index1)}
              >
                <div className={classes.categoryImage}>
                  <img src={category.src} alt={category.name} />
                </div>
                <div className={classes.categoryTitle}>
                  <Typography variant="h6">{category.name}</Typography>
                </div>
                {category.open ? (
                  <ArrowBackIosRoundedIcon
                    className={classes.categoryIconActive}
                  />
                ) : (
                  <ArrowBackIosRoundedIcon
                    className={classes.categoryIconInactive}
                  />
                )}
              </div>
              <Collapse in={category.open}>
                {category.rates.map((rate, index2) => {
                  return <TemplateSetRate rate={rate} key={index2} />;
                })}
              </Collapse>
            </div>
          );
        })}
      </div>
    );
  }
}

export default withStyles(styles)(TemplateSetList);
